const REFERENCE_TYPES = ["output", "metaoutput", "user-defined-variable"];

export function tokensToText(rawValue: unknown): string {
  if (typeof rawValue !== "string" || rawValue === "" || rawValue === "[]") {
    return "";
  }

  let tokens: unknown;
  try {
    tokens = JSON.parse(rawValue);
  } catch {
    return rawValue;
  }

  if (!Array.isArray(tokens)) {
    return rawValue;
  }

  return tokens
    .map((token: any) => {
      const name = typeof token?.name === "string" ? token.name : "";
      const type = token?.type;

      if (REFERENCE_TYPES.includes(type)) {
        return name.startsWith("/") ? `var(${name.replace("/", "/#")})` : name;
      }

      if (type === "system-variable") {
        return name ? `(sys/${name})` : "";
      }

      return name;
    })
    .join("");
}

export function isValidJsonBody(text: unknown): boolean {
  if (typeof text !== "string" || !text.trim()) {
    return true;
  }

  try {
    JSON.parse(text);
    return true;
  } catch {
    return false;
  }
}
